import React, { useState } from "react";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import Table from "shared/components/data-display/tables/Table";
import TableFilters from "shared/components/data-display/tables/TableFilters";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";

const NumberColumnAccessorName = "JobCode";
const columns = [
    {
        headCellProps: {
            text: "Number",
            width: "25%",
        },

        getBodyCellProps: (cell) => ({
            text: cell.value,
        }),
        filter: (rows, _columnIds, filterValue) => {
            return rows?.filter((row) => {
                return (
                    (filterValue === "active" && row.values.Active === true) ||
                    (filterValue === "inactive" && row.values.Active === false)
                );
            });
        },
        accessor: NumberColumnAccessorName,
    },
    {
        headCellProps: {
            text: "Name",
            width: "70%",
        },
        getBodyCellProps: (cell) => ({
            text: cell.value ?? "-",
        }),
        accessor: "Name",
    },
    {
        accessor: "Active",
        disableSortBy: true,
        getBodyCellProps: (cell) => ({
            shownByRowHover: true,
            actionIcon: "delete",
            actionProps: {
                to: `?action=delete&linkId=${cell.row.original.relatedJobID}`,
                replace: true,
                "aria-label": "Delete",
            },
        }),
    },
];

const FiltersConfig = [
    {
        name: "active",
        columnAccessor: NumberColumnAccessorName,
        unfilteredValue: "all",
        isSegmentedControl: true,
        options: [
            {
                value: "all",
                label: "All",
            },
            {
                value: "active",
                label: "Active",
            },
            {
                value: "inactive",
                label: "Inactive",
            },
        ],
    },
];

const getRowProps = (row) => ({
    style: {
        background: row.values.Active === false ? COLOR_VALUES.Gray_9 : "",
    },
});

const ProjectsContentStudioTable = ({ contentStudioProjects }) => {
    const [filters, setFilters] = useState();

    return (
        <>
            {contentStudioProjects.length > 0 && (
                <VStack style={{ width: "100%" }}>
                    <VStack spacing="Zero_5">
                        <Text variant="Headline_2" color="Gray_1">
                            Content Studio
                        </Text>

                        <Text variant="Body_2_1" color="Gray_2">
                            Linked Projects from Content Studio
                        </Text>
                    </VStack>
                    <HStack align="end" justify="space-between">
                        <TableFilters
                            filtersConfig={FiltersConfig}
                            onChange={setFilters}
                        />
                    </HStack>
                    <Table
                        columns={columns}
                        data={contentStudioProjects}
                        filters={filters}
                        getRowProps={getRowProps}
                    />
                </VStack>
            )}
        </>
    );
};

ProjectsContentStudioTable.propTypes = {
    contentStudioProjects: PropTypes.array.isRequired,
};

export default React.memo(ProjectsContentStudioTable);
